import { Dropdown } from '@factorialco/factorial-one-react/dist/experimental'
import {
  AlignTextLeft,
  Bullet,
  Check,
  CheckDouble,
  Delete,
  GroupBy,
  Numbers,
  Star,
  TextSize,
} from '@factorialco/factorial-one-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { elementFromData, getDefaultOptions } from 'modules/forms/hooks/useForms'
import { Element } from 'modules/forms/lib/Element'

const QuestionContentDropdown = ({
  element,
  onChange,
  onDelete,
}: {
  element: Element
  onChange: (element: Element) => void
  onDelete: () => void
}) => {
  const changeElementType = (type: FormsElementTypeEnum) => {
    const newElement = elementFromData({
      id: element.id,
      description: element.description,
      label: element.label,
      mandatory: element.mandatory,
      options: getDefaultOptions(type),
      params: '{}',
      position: element.position,
      sectionId: element.sectionId || undefined,
      type: type,
    })

    onChange(newElement)
  }

  return (
    <Dropdown
      items={[
        !element?.mandatory && {
          label: i18n.t('forms.modals.actions.mark_as_mandatory'),
          icon: CheckDouble,
          onClick: () => {
            element.mandatory = true
            onChange(element)
          },
        },
        element?.mandatory && {
          label: i18n.t('forms.modals.actions.mark_as_optional'),
          icon: CheckDouble,
          onClick: () => {
            element.mandatory = false
            onChange(element)
          },
        },
        !element.getParam('optional_comment') && {
          label: i18n.t('forms.modals.actions.optional_comment_enable'),
          icon: AlignTextLeft,
          onClick: () => {
            element.setParam('optional_comment', true)
            onChange(element)
          },
        },
        element.getParam('optional_comment') && {
          label: i18n.t('forms.modals.actions.optional_comment_disable'),
          icon: AlignTextLeft,
          onClick: () => {
            element.deleteParam('optional_comment')
            onChange(element)
          },
        },
        {
          type: 'separator',
        },
        {
          label: i18n.t('forms.modals.elements.single_choice'),
          icon: Bullet,
          onClick: () => changeElementType('select'),
        },
        {
          label: i18n.t('forms.modals.elements.multiple_choice'),
          icon: Check,
          onClick: () => changeElementType('multiselect'),
        },
        {
          label: i18n.t('forms.modals.elements.rating'),
          icon: Star,
          onClick: () => changeElementType('rating'),
        },
        {
          label: i18n.t('forms.modals.elements.numeric'),
          icon: Numbers,
          onClick: () => changeElementType('number'),
        },
        {
          label: i18n.t('forms.modals.elements.text'),
          icon: TextSize,
          onClick: () => changeElementType('text'),
        },
        {
          label: i18n.t('forms.modals.elements.section'),
          icon: GroupBy,
          onClick: () => changeElementType('section'),
        },
        {
          type: 'separator',
        },
        {
          label: i18n.t('forms.modals.actions.delete'),
          icon: Delete,
          onClick: onDelete,
        },
      ].filter(Boolean)}
    />
  )
}

export default QuestionContentDropdown
